import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import context from '@/context'

function PermissionRequired (props) {
  function isGranted (permissionName) {
    return props.permissionsGranted[permissionName] || false
  }

  if (typeof props.children === 'function') {
    return props.children(isGranted)
  }
  let hasPermission = false
  if (typeof props.name === 'object' && Array.isArray(props.name)) {
    for (let permissionName of props.name) {
      hasPermission = hasPermission || isGranted(permissionName)
    }
  } else {
    hasPermission = isGranted(props.name)
  }
  return hasPermission ? React.Children.only(props.children) : null
}

PermissionRequired.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
}

const permissionsGrantedSelector = context.isInternalApp()
  ? state => state.permissions.granted.filter(x => !x.startsWith('Scopes.'))
  : state => state.permissions.granted
const taskPermissionsGrantedSelector = state => state.myActiveTask && state.myActiveTask.activeTask &&
  state.myActiveTask.activeTask.type &&
  state.myActiveTask.activeTask.type.permissions

const allGrantedPermissionsSelector = createSelector(permissionsGrantedSelector, taskPermissionsGrantedSelector,
  (p1, p2) => {
    const all = {}
    p1 && p1.forEach(p => { all[p] = true })
    p2 && p2.forEach(p => { all[p] = true })
    return all
  })

function mapStateToProps (state) {
  return {
    permissionsGranted: allGrantedPermissionsSelector(state)
  }
}

export default connect(mapStateToProps)(PermissionRequired)



// WEBPACK FOOTER //
// ./src/components/auth/PermissionRequired.js